import type { ErrorLabelStyles } from '../../ThemeTypes';
import colors from '../colors';
import fonts from '../fonts';

/**
 * Error label styles for the Loop theme
 * TypeScript representation of _error-label.scss
 */
export const errorLabel: ErrorLabelStyles = {
  errorLabel: {
    fontSize: fonts.fontSizes.sm,
    color: colors.error,
  },
};

export default errorLabel;
